import configuration from './../config.json'
import CarsService from '../shared/services/carsService'
import CookieService from './../shared/services/cookiesService'
import { setLogout } from './authActions'

const REQUEST_SET_CAR_BOOKMARK = 'REQUEST_SET_CAR_BOOKMARK'
const RESPONSE_SET_CAR_BOOKMARK = 'RESPONSE_SET_CAR_BOOKMARK'
const REQUEST_SET_CAR_BOOKMARK_FAILURE = 'REQUEST_SET_CAR_BOOKMARK_FAILURE'

const requestSetCarBookmarkAction = () => {
  return {
    type: REQUEST_SET_CAR_BOOKMARK
  }
}

const responseSetCarBookmarkAction = () => {
  return {
    type: RESPONSE_SET_CAR_BOOKMARK
  }
}

const requestSetCarBookmarkFailureAction = (errors) => {
  return {
    type: REQUEST_SET_CAR_BOOKMARK_FAILURE,
    errors
  }
}

const setCarBookmark = (id) => {
  return (dispatch) => {
    dispatch(requestSetCarBookmarkAction())

    CarsService.setBookmark(id)
      .then((result) => {
        CookieService.updateExpires(configuration.cookieName, 12)

        dispatch(responseSetCarBookmarkAction())
      })
      .catch((error) => {
        dispatch(requestSetCarBookmarkFailureAction(error.response))

        if (error.response && error.response.status === 401) {
          dispatch(setLogout())
        }
      })
  }
}

export {
  setCarBookmark,
  requestSetCarBookmarkAction,
  responseSetCarBookmarkAction,
  requestSetCarBookmarkFailureAction,
  REQUEST_SET_CAR_BOOKMARK,
  RESPONSE_SET_CAR_BOOKMARK,
  REQUEST_SET_CAR_BOOKMARK_FAILURE
}